import { LayoutHOC } from 'base/ui/layout/layout';
import { createEditProduct } from './editProduct';

export const createEditProductPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createEditProduct());
};
